import apiCall from "./apiCall";

export default {
  async getMainAccounts(data) {
    let response = await apiCall("accounts/get_main_accounts", data);
    return response;
  },
  // ledger types works
  async createLedgerType(data) {
    let response = await apiCall("accounts/createLegderType", data);
    return response;
  },
  async UpdateLedgerGroup(data) {
    let response = await apiCall("accounts/update_ledger_group", data);
    return response;
  },
  async getLedgerTypes(data) {
    let response = await apiCall("accounts/fetchLedger_types", data);
    return response;
  },

  // ledgers functions
  async getLedgers(data) {
    let response = await apiCall("accounts/get_ledgers", data);
    return response;
  },
  async createLedger(data) {
    let response = await apiCall("accounts/create_ledger", data);
    return response;
  },
  async getALlLedgersMinData(data) {
    let response = await apiCall("accounts/list_all_ledger_minimal_data", data);
    return response;
  },
  async getALlLedgersMinData_non_cash_or_bank(data) {
    let response = await apiCall(
      "accounts/list_ledgers_all_mini_data_non_cash_or_bank",
      data
    );
    return response;
  },
  async getALlLedgersMinData_cash_or_bank(data) {
    let response = await apiCall(
      "accounts/list_ledgers_all_mini_data_cash_or_bank",
      data
    );
    return response;
  },
  async deactivateLedger(data) {
    let response = await apiCall("accounts/deactivate_ledger", data);
    return response;
  },
  async UpdateLedger(data) {
    let response = await apiCall("accounts/update_legder", data);
    return response;
  },
  // cost allocation center
  async create_cost_allocationItem(data) {
    let response = await apiCall("accounts/create_cost_allocation_item", data);
    return response;
  },
  async list_cost_allocationItems(data) {
    let response = await apiCall("accounts/list_cost_allocation_items", data);
    return response;
  },
  async get_cost_allocation_expenditures(data) {
    let response = await apiCall(
      "accounts/get_cost_allocation_expenditures",
      data
    );
    return response;
  },
  async delete_cost_allocationItem(data) {
    let response = await apiCall(
      "accounts/delete_cost_allocation_center",
      data
    );
    return response;
  },
  async UpdateCostAllocationCenter(data) {
    let response = await apiCall(
      "accounts/update_cost_allocation_center",
      data
    );
    return response;
  },
  async getAllcostAllocations_min_data() {
    let response = await apiCall(
      "accounts/list_cost_all_allocation_items_min_data"
    );
    return response;
  },
  // budget expenditures
  async createBugdetExpense(data) {
    let response = await apiCall("accounts/create_budget_expenditure", data);
    return response;
  },
  async UpdateBudgetExpenditure(data) {
    let response = await apiCall("accounts/update_budget_expenditure", data);
    return response;
  },
  async getBudgetExpenses(data) {
    let response = await apiCall("accounts/list_budget_trnsactions", data);
    return response;
  },
  async setBudegetExpenditure_costAllocation(data) {
    let response = await apiCall("accounts/set_this_budget_expense_cat", data);
    return response;
  },
  // PaymentVoucher
  async CreatePaymentVoucher(data) {
    let response = await apiCall("accounts/create_Transctions", data);
    return response;
  },

  async getPaymentVoucher(data) {
    let response = await apiCall("accounts/list_Transctions", data);
    return response;
  },

  async getTransactionsForexport(data) {
    let response = await apiCall("accounts/list_Transctions_All", data);
    return response;
  },
  async getInvoicesForExport(data) {
    let response = await apiCall("accounts/list_all_invoices_for_export", data);
    return response;
  },
  async setPaymentVoucher_costAllocation(data) {
    let response = await apiCall("accounts/set_payment_vouchers_cat", data);
    return response;
  },
  async delete_transaction_costAllocation(data) {
    let response = await apiCall("accounts/delete_transaction_cat_item", data);
    return response;
  },
  async getPaymentVoucher_costAllocation(data) {
    let response = await apiCall(
      "accounts/get_transaction_cost_allocation_item",
      data
    );
    return response;
  },
  async Update_payment_voucher(data) {
    let response = await apiCall("accounts/update_transaction", data);
    return response;
  },
  async getFolioVouchersList(data) {
    let response = await apiCall(
      "accounts/get_folio_transactions_for_printing",
      data
    );
    return response;
  },
  async getprojectBudgectExpense(data) {
    let response = await apiCall(
      "accounts/get_budget_expenditure_report",
      data
    );
    return response;
  },
  async getLedgerTrialStatement(data) {
    let response = await apiCall("accounts/get_ledger_account_trial", data);
    return response;
  },
  async getProjectTrialBalanceReportGroupIDs(data) {
    let response = await apiCall(
      "accounts/get_project_trial_balance_ledger_groups",
      data
    );
    return response;
  },
  async getProjectTrialBalanceReportGroup(data) {
    let response = await apiCall(
      "accounts/get_project_trial_balance_ledger_group",
      data
    );
    return response;
  },
  // invoices works
  async createInvoicables(data) {
    let response = await apiCall("accounts/create_invoicables", data);
    return response;
  },
  async getInvoicables(data) {
    let response = await apiCall("accounts/listInvoicables", data);
    return response;
  },

  async deactivateInvoicable(data) {
    let response = await apiCall("accounts/deactivate_invoicable_item", data);
    return response;
  },
  async updateInvoicableItem(data) {
    let response = await apiCall("accounts/update_invoicable_item", data);
    return response;
  },
  async getAllSalesInvoices() {
    let response = await apiCall("accounts/get_sales_ledgers");
    return response;
  },
  async getClientLedgers() {
    let response = await apiCall("accounts/list_clients_ledgers");
    return response;
  },
  async createInvoice(data) {
    let response = await apiCall("accounts/create_invoice_and_details", data);
    return response;
  },
  async UpdateInvoice(data) {
    let response = await apiCall("accounts/update_invoice_and_details", data);
    return response;
  },
  async fetchInvoices(data) {
    let response = await apiCall("accounts/get_invoices", data);
    return response;
  },
  async fetchInvoices_not_fully_paid(data) {
    let response = await apiCall("accounts/get_invoices_not_paid_fully", data);
    return response;
  },
  async fetchInvoices_fully_paid(data) {
    let response = await apiCall("accounts/get_invoices_paid_fully", data);
    return response;
  },
  async getInvoice_and_details(data) {
    let response = await apiCall("accounts/get_invoice_details", data);
    return response;
  },
  async getInvoice_statement(data) {
    let response = await apiCall("accounts/get_invoice_statement", data);
    return response;
  },
  async getsupplierInvoice_statement(data) {
    let response = await apiCall("accounts/get_supplier_reff_statement", data);
    return response;
  },
  async createJournalInventory(data) {
    let response = await apiCall("accounts/create_journal_invetory", data);
    return response;
  },
  async update_journal_invetory(data) {
    let response = await apiCall("accounts/update_journal_invetory", data);
    return response;
  },
  async createInventoryInvoice(data) {
    let response = await apiCall("accounts/create_invoice_invetory", data);
    return response;
  },
  async get_Inventory_invoice(data) {
    let response = await apiCall(
      "accounts/get_inventory_journal_details",
      data
    );
    return response;
  },
  async getInvoiceReferences(data) {
    let response = await apiCall(
      "accounts/get_invoice_reference_with_balance",
      data
    );
    return response;
  },
  async getSupplierInvoiceReferences(data) {
    let response = await apiCall(
      "accounts/get_supplier_invoice_reference_with_balance",
      data
    );
    return response;
  },
  async createDepositTransaction(data) {
    let response = await apiCall("accounts/create_deposite_transaction", data);
    return response;
  },
  async createcreditTransaction(data) {
    let response = await apiCall("accounts/create_credit_transaction", data);
    return response;
  },
  async getProjectsProfitAndLossesReport(data) {
    let response = await apiCall(
      "accounts/get_projects_profit_and_losses_report",
      data
    );
    return response;
  },
  async getProjectsBalanceSheetReport(data) {
    let response = await apiCall("accounts/get_projects_balancesheet", data);
    return response;
  },
  async getTransactionsAll(data) {
    let response = await apiCall("accounts/list_all_transctions", data);
    return response;
  },
  async CreateJournal(data) {
    let response = await apiCall("accounts/create_Journal_Transctions", data);
    return response;
  },
  async getUnpaidJournals(data) {
    let response = await apiCall(
      "accounts/list_transctions_journals_payment_state",
      data
    );
    return response;
  },
  async DeleteTransaction(data) {
    let response = await apiCall("accounts/delete_transaction", data);
    return response;
  },
  async DeleteJournalTransaction(data) {
    let response = await apiCall("accounts/delete_journal_transaction", data);
    return response;
  },
  async DeleteinventoryJournalTransaction(data) {
    let response = await apiCall(
      "accounts/delete_inventory_journal_transaction",
      data
    );
    return response;
  },
  async DeleteinvoiceTransaction(data) {
    let response = await apiCall("accounts/delete_invoice_transaction", data);
    return response;
  },
};
